if (!customElements.get('theme-slider')) {
  customElements.define(
    'theme-slider',
    class ThemeSlider extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.getAttribute('data-section-id');

        this.slider = this.querySelector('.swiper');
        if (!this.slider) return;
        this.initSlider();
        this.initVideoPlaying();
      }

      get sliderType() {
        return this.dataset.slider;
      }

      get slidesQuantityMobile() {
        return Number(this.dataset.slidesMobile);
      }

      get slidesQuantityDesktop() {
        return Number(this.dataset.slidesDesktop);
      }

      get sliderButtons() {
        return Boolean(this.dataset.buttons);
      }

      get visibleSlides() {
        return this.querySelectorAll('.theme-slide:not([aria-hidden])').length;
      }

      initSlider(update) {
        let Slider;
        const options = {
          observer: true,
          observeParents: true,
          slidesPerMove: 1,
          grabCursor: true,
          slidesPerView: this.visibleSlides <= this.slidesQuantityMobile ? this.visibleSlides : this.slidesQuantityMobile,
          spaceBetween: 12,
          slidesOffsetAfter: 12,
          noSwiping: true,
          noSwipingClass: 'swiper-no-swiping',
          mousewheel: {
            forceToAxis: true,
          },
          breakpoints: {
            750: {
              slidesPerView: this.visibleSlides <= this.slidesQuantityMobile + 1 ? this.visibleSlides : this.slidesQuantityMobile + 1,
            },
            990: {
              slidesPerView: this.slidesQuantityDesktop,
              slidesPerView: this.visibleSlides <= this.slidesQuantityDesktop ? this.visibleSlides : this.slidesQuantityDesktop,
              spaceBetween: 20,
              slidesOffsetAfter: 20,
            },
          },
        };

        if (this.sliderButtons) {
          options.navigation = {
            nextEl: this.querySelector(`.slider-next-${this.sectionId}`),
            prevEl: this.querySelector(`.slider-prev-${this.sectionId}`),
          };
        }

        switch (this.sliderType) {
          case 'mobile':
            if (window.innerWidth >= 750) return;
            Slider = new Swiper(`.swiper--${this.sectionId}`, options);
            break;
          case 'desktop':
            if (window.innerWidth < 750) return;
            Slider = new Swiper(`.swiper--${this.sectionId}`, options);
            break;
          case 'both':
            Slider = new Swiper(`.swiper--${this.sectionId}`, options);
            break;
        }

        if (update) {
          setTimeout(() => {
            Slider.update();
          });
        }
      }

      initVideoPlaying() {
        const videoSlides = this.querySelectorAll('[data-video]');
        if (videoSlides.length === 0) return;
        videoSlides.forEach((slide) => {
          const videos = slide.querySelectorAll('video');
          if (videos.length === 0) return;
          if (videos.length === 1) {
            this.observVideo(videos[0]);
          } else {
            const matchesBreakpoint = (video) => (window.innerWidth > 1024 && video.classList.contains('image-desktop')) || (window.innerWidth <= 1024 && video.classList.contains('image-mobile'));
            videos.forEach((video) => {
              if (matchesBreakpoint(video)) {
                this.observVideo(video);
              }
            });
          }
        });
      }

      observVideo(video) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              video.play();
            } else {
              video.pause();
            }
          });
        });
        observer.observe(video);
      }
    }
  );
}
